import {useAppSelector} from "@/hooks";

export const useBusinessProfileBrandIdFromBrandsStore = (): string | null => {
    return useAppSelector(({brands}) => {
        return brands.businessProfileBrandId as string | null;
    })
}